import React from 'react';

function Support() {
  return (
    <div className="container">
      <article className="page support-page">
        <h1>Support</h1>
        <p className="updated">Need help with Construction Calculator? We are here to help.</p>

        <p>
          For app support, bug reports, billing questions, feature requests or
          help with calculations, email us at{' '}
          <a href="mailto:support@fairappsstore.com">support@fairappsstore.com</a>.
        </p>

        <div className="support-contact">
          <div>
            <span>Email support</span>
            <strong>support@fairappsstore.com</strong>
          </div>
          <a className="btn btn-gradient" href="mailto:support@fairappsstore.com">
            Contact Support
          </a>
        </div>

        <h2>What to include</h2>
        <ul>
          <li>Your device model and Android or iOS version.</li>
          <li>The calculator, template or feature you were using.</li>
          <li>A short description of what happened and what you expected.</li>
          <li>Screenshots or screen recordings if they help explain the issue.</li>
        </ul>

        <h2>Common help topics</h2>
        <div className="support-grid">
          <section>
            <h3>Calculation questions</h3>
            <p>
              Send the values you entered and the result you expected. We can
              review the formula and help you understand the estimate.
            </p>
          </section>
          <section>
            <h3>App install issues</h3>
            <p>
              Make sure your device has enough storage and is running a
              supported operating system version, then try reinstalling the app.
            </p>
          </section>
          <section>
            <h3>PDF reports</h3>
            <p>
              If reports are not exporting or sharing correctly, include your
              device details and the project type in your message.
            </p>
          </section>
          <section>
            <h3>Privacy requests</h3>
            <p>
              For questions about your data or deletion requests, contact us
              from the email account you used to reach support.
            </p>
          </section>
        </div>

        <h2>Response time</h2>
        <p>
          We try to respond to support emails within 2 business days. Complex
          calculation reviews or bug investigations may take longer.
        </p>
      </article>
    </div>
  );
}

export default Support;
